export const HIGHER_EXCESS = "Higher Excess";
export const LOWER_EXCESS = "Lower Excess";
export const ZERO_EXCESS = "Zero Excess";